import CommonComponents from './common';
import WelcomeComponents from './welcome';
import HomeLayoutComponents from './home-layout';
import PendingAppsComponents from './pending-apps';
import ActiveProgramsComponents from './active-programs';
import ClosedProgramsComponents from './closed-programs';
import ResourcesComponents from './resources';

const components = [
  ...CommonComponents,
  ...WelcomeComponents,
  ...HomeLayoutComponents,
  ...PendingAppsComponents,
  ...ActiveProgramsComponents,
  ...ClosedProgramsComponents,
  ...ResourcesComponents
];

const plugin = (Vue) => {
  components.forEach((component) => {
    Vue.component(component.name, component);
  });
};

export default plugin;



// WEBPACK FOOTER //
// ./src/components/index.js